/* eslint-disable no-negated-condition */
import React, { useState } from "react";
import {
  Columns,
  Column,
  Heading,
  HeadingProps,
} from "@origin-digital/ods-core";
import styled from "styled-components";
import { ActionBarMobileProps, getMobileNavButton } from "./ActionBarMobile";
import {
  hasSelectedPremise,
  isSinglePremise,
  isEmptyPremise,
  getSelectProps,
} from "./utils";
import { CompactSelect, FullSelect } from "./PropertySelect";
import { PropertyPopper } from "./PropertyPopper/PropertyPopper";
import { Box } from "./Box";

export const FullContainer = styled(Box)`
  width: 100%;
  height: 48px;
`;

const CustomHeading = ({
  className,
  children,
  component,
  "data-id": dataId,
}: HeadingProps) => (
  <Heading
    variant="h4"
    className={className}
    component={component}
    data-id={dataId}
  >
    {children}
  </Heading>
);

const StyledCustomHeading = styled(CustomHeading)`
  && {
    font-size: 14px;
  }
`;

const RowContainer = styled(Box)`
  height: 44px;
`;

const ButtonContainer = styled(Box)`
  width: 54px;
  margin-left: -2px;
  margin-right: 2px;
`;

export const NavTitle = ({
  mobileNavButton,
  onClickMobileNavButton,
  headingComponent,
  title,
  mobilePropertySelector,
  premises,
  selectedPremiseId,
  handleOnSelectPremise,
  desktopVariant,
  isDesktop,
}: ActionBarMobileProps) => {
  const [mobileRef, setMobileRef] = useState<HTMLElement | null>(null);
  return (
    <Box backgroundColor="white">
      <Columns space="none" alignY="center">
        {!isDesktop || desktopVariant === "slim" ? (
          <>
            <Column width={!isDesktop ? "content" : "flex"}>
              <RowContainer display="flex" alignItems="center">
                <ButtonContainer display="flex">
                  {getMobileNavButton(
                    mobileNavButton,
                    onClickMobileNavButton,
                    isDesktop,
                    desktopVariant
                  )}
                </ButtonContainer>
              </RowContainer>
            </Column>
            <Column alignX="center">
              <StyledCustomHeading
                data-id="actionbar-heading-mobile"
                variant="h4"
                component={headingComponent}
              >
                {title}
              </StyledCustomHeading>
            </Column>
          </>
        ) : null}
        <Column width={!isDesktop ? "content" : "flex"} alignX="right">
          <Box
            data-id="actionbar-address-select-compact-mobile-container"
            display="flex"
            style={{ height: "44px", width: isDesktop ? "auto" : "48px" }}
            justifyContent="flex-end"
            innerRef={setMobileRef}
          >
            {mobilePropertySelector === "compact" &&
            desktopVariant !== "slim" &&
            hasSelectedPremise(premises, selectedPremiseId) &&
            !isSinglePremise(premises) &&
            !isEmptyPremise(premises) ? (
              <>
                <Box
                  backgroundColor="white"
                  display="flex"
                  paddingLeft="medium"
                  paddingRight="small"
                  alignItems="center"
                  justifyContent="center"
                  style={{ width: "70px" }}
                >
                  <CompactSelect
                    data-id="actionbar-address-select-compact-mobile"
                    {...getSelectProps({
                      handleOnSelectPremise,
                      premises,
                      selectedPremiseId,
                    })}
                  />
                </Box>
                <PropertyPopper id="compact-popper" anchorEl={mobileRef} />
              </>
            ) : null}
            {desktopVariant === "slim" &&
            !isSinglePremise(premises) &&
            isDesktop &&
            (mobilePropertySelector === "compact" ||
              mobilePropertySelector === "full") ? (
              <>
                <FullContainer
                  backgroundColor="white"
                  display="flex"
                  paddingLeft="medium"
                  paddingRight="small"
                  alignItems="center"
                  justifyContent="center"
                >
                  <FullSelect
                    data-id="actionbar-address-select-full-mobile"
                    {...getSelectProps({
                      handleOnSelectPremise,
                      premises,
                      selectedPremiseId,
                    })}
                  />
                  <PropertyPopper id="mobile-popper" anchorEl={mobileRef} />
                </FullContainer>
              </>
            ) : (
              <></>
            )}
          </Box>
        </Column>
      </Columns>
    </Box>
  );
};
